export const filterByText = (search: string, data: string[]) => {
  return search
    ? data.filter((item) => item.toLowerCase().indexOf(search.toLowerCase()) !== -1)
    : data;
};
